import React from "react"
const SessionTypeLiveGroupIcon = () => {
    return (
        <span className="material-icons">groups</span>
    )
}
export default SessionTypeLiveGroupIcon